export default __webpack_public_path__ + "static/1719-efd7efd03f6ee72a98fb4e4244e8ece8.gif";